const applyInlineFormatting = (text: string): string => {
  return text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/_(.+?)_/g, '<em>$1</em>')
    .replace(/<u>(.+?)<\/u>/g, '<u>$1</u>');
};

export const formatDescriptionHtml = (description?: string): string => {
  if (!description) return '';

  const lines = description.split(/\r?\n/);
  let html = '';
  let inUnorderedList = false;
  let inOrderedList = false;

  const closeLists = () => {
    if (inUnorderedList) {
      html += '</ul>';
      inUnorderedList = false;
    }
    if (inOrderedList) {
      html += '</ol>';
      inOrderedList = false;
    }
  };

  lines.forEach((line) => {
    const trimmed = line.trim();

    if (!trimmed) {
      closeLists();
      html += '<br />';
      return;
    }

    const formattedLine = applyInlineFormatting(trimmed);

    const bulletMatch = /^[-*•]\s*(.*)$/.exec(formattedLine);
    if (bulletMatch) {
      if (!inUnorderedList) {
        closeLists();
        html += '<ul>';
        inUnorderedList = true;
      }
      html += `<li>${bulletMatch[1]}</li>`;
      return;
    }

    const numberedMatch = /^(\d+)\.\s*(.*)$/.exec(formattedLine);
    if (numberedMatch) {
      if (!inOrderedList) {
        closeLists();
        html += '<ol>';
        inOrderedList = true;
      }
      html += `<li>${numberedMatch[2]}</li>`;
      return;
    }

    closeLists();
    html += `<p>${formattedLine}</p>`;
  });

  closeLists();
  return html;
};
